import {Inject, Injectable, PLATFORM_ID} from '@angular/core';
import {HttpErrorResponse, HttpEvent, HttpHandler, HttpInterceptor, HttpRequest} from '@angular/common/http';
import {Observable, throwError} from 'rxjs';
import {catchError} from 'rxjs/operators';
import {Router} from '@angular/router';
import {isPlatformBrowser} from '@angular/common';
import {GuestAccountError} from '../models/guest-account-error.model';
import {GUEST_USER_INFO_ROUTE, GuestAccountService} from './guest-account.service';

/**
 * SSO-Gast-Accounts sind Read-Only und dürfen im WebAbo nichts auslösen — das Backend beantwortet
 * jeden identitätspflichtigen Aufruf mit 403 (`GUEST_ACCOUNT_FORBIDDEN`), auch `/webabo/users`.
 * Statt in jedem Feature eine eigene Fehlermeldung zu bauen, landet der Nutzer hier einmalig auf
 * einer Info-Seite mit Abmelde-Möglichkeit.
 *
 * Der Fehler wird bewusst weitergereicht, damit laufende Ladeanzeigen der Aufrufer beendet werden.
 */
@Injectable()
export class GuestAccountInterceptor implements HttpInterceptor {
  constructor(
    private router: Router,
    private guestAccountService: GuestAccountService,
    @Inject(PLATFORM_ID) private platformId: Object) {
  }

  intercept(req: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
    return next.handle(req).pipe(
      catchError((error: unknown) => {
        if (GuestAccountError.isGuestAccountError(error)) {
          this.showInformationPage(error as HttpErrorResponse);
        }
        return throwError(() => error);
      })
    );
  }

  private showInformationPage(error: HttpErrorResponse): void {
    // Auf dem Server würde eine Navigation mitten im Rendern den Renderlauf stören; der Browser
    // wiederholt die Aufrufe nach der Hydration ohnehin und navigiert dann.
    if (!isPlatformBrowser(this.platformId) || this.guestAccountService.isBlocked()) {
      return;
    }
    this.guestAccountService.markBlocked();
    console.warn('guest-account: Aufruf für Gast-Benutzer abgelehnt, leite auf die Info-Seite um:', error.url);
    this.router.navigateByUrl(GUEST_USER_INFO_ROUTE, {skipLocationChange: true})
      .catch(navigationError => console.error('guest-account: Navigation auf die Info-Seite fehlgeschlagen', navigationError));
  }
}
